import { render, staticRenderFns } from "./inforlist.html?vue&type=template&id=e6733626&scoped=true&"
import script from "./inforlist.js?vue&type=script&lang=js&"
export * from "./inforlist.js?vue&type=script&lang=js&"
import style0 from "./inforlist.sass?vue&type=style&index=0&id=e6733626&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6733626",
  null
  
)

component.options.__file = "inforlist.vue"
export default component.exports